module.exports = __webpack_public_path__ + "img/20201024_101244.7f9ea40c.jpg";